import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-modal-carga-component',
  standalone: true,
  imports: [],
  templateUrl: './modal-carga-component.html',
  styleUrl: './modal-carga-component.scss'
})
export class ModalCargaComponent {
  @Input() title!: string;
  @Input() subTitle!: string;

}
